import {getFlag} from 'components/cabinet/calculator/components/delivery/helpers';

const LocationFlag = ({code}: CalculatorLocationFlagProps) => {
  return <span className='location-flag' style={{
    display: 'inline-flex',
    width: '24px',
    height: '18px',
  }}>
    {getFlag({code, width: '24px', marginRight: '0'})}
  </span>;
};

export default LocationFlag;
